const baseUrl = process.env.REACT_APP_FIREBASE_API_URL || 'http://localhost:5001/codeacademy-online/europe-west1';

export const saveUnauthorizedUser = async (email: string, name: string, phone: string) => {
    try {
        const response = await fetch(`${baseUrl}/unauthorizedUsers`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: email.trim().toLowerCase(),
                name: name.trim(),
                number: phone.trim(),
            }),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        // fail silently
        return null;
    }
};
